import _get from 'lodash.get';

function extractApplePayToken(state) {
    const token = _get(state, 'data.paymentMethod.applePayToken', null);
    return typeof token === 'string' ? token : null;
}

export { extractApplePayToken };
//# sourceMappingURL=AdyenApplePayButton.static.js.map
